module.exports = __webpack_public_path__ + "img/CersoBleek.9f87263f.png";